/* Complete organization cards and native links remain usable without JavaScript. */
document.querySelectorAll('[data-team-lineups]').forEach(function (root) {
  if (root.dataset.lineupsReady) return;
  root.dataset.lineupsReady = 'true';
  var controls = root.querySelector('[data-lineup-controls]');
  if (!controls) return;
  var cards = Array.from(root.querySelectorAll('[data-lineup-organization]'));
  var buttons = Array.from(controls.querySelectorAll('[data-lineup-filter]'));
  var count = root.querySelector('[data-lineup-count]');
  var groups = Array.from(root.querySelectorAll('[data-lineup-group]'));
  function filter(value) {
    buttons.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.lineupFilter === value)); });
    var visibleTeams = 0;
    var visiblePrograms = 0;
    var pendingPrograms = 0;
    cards.forEach(function (card) {
      var shown = 0;
      card.querySelectorAll('[data-lineup-class]').forEach(function (program) {
        program.hidden = value !== 'all' && program.dataset.lineupClass !== value && program.dataset.lineupClass !== 'unconfirmed';
        if (!program.hidden) {
          shown++;
          visiblePrograms++;
          if (program.dataset.lineupStatus === 'awaiting_announcement') pendingPrograms++;
        }
      });
      card.hidden = shown === 0;
      card.dataset.visiblePrograms = String(shown);
      if (shown) visibleTeams++;
    });
    groups.forEach(function (group) {
      var shown = Array.from(group.querySelectorAll('[data-lineup-organization]')).filter(function (card) { return !card.hidden; }).length;
      group.hidden = shown === 0;
      var label = group.querySelector('[data-lineup-group-count]');
      if (label) label.textContent = shown + (shown === 1 ? ' team' : ' teams');
    });
    count.textContent = visibleTeams + (visibleTeams === 1 ? ' team' : ' teams') + ' · ' + visiblePrograms + (visiblePrograms === 1 ? ' class program' : ' class programs') + ' · ' + pendingPrograms + (pendingPrograms === 1 ? ' program pending' : ' programs pending');
  }
  buttons.forEach(function (button) { button.addEventListener('click', function () { filter(button.dataset.lineupFilter); }); });
  controls.hidden = false;
  filter('all');
});
